(() => {
  if (window.CelloBagWholesaleRebuild) { window.CelloBagWholesaleRebuild.initAll(document); return; }
  const number = value => new Intl.NumberFormat('en-GB').format(value);
  const money = cents => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(cents / 100);
  const integer = value => {
    const raw = String(value).replace(/[\s,]/g, '');
    if (!/^\d+$/.test(raw)) return NaN;
    const parsed = Number(raw);
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : NaN;
  };
  function init(root) {
    if (root.dataset.ready === 'true') return;
    const one = s => root.querySelector(s);
    const many = s => Array.from(root.querySelectorAll(s));
    const form = one('form');
    const priceSize = one('[data-price-size]');
    const panels = many('[data-size-panel]');
    const route = one('[data-route]');
    const size = one('[data-form-size]');
    const quantity = one('input[data-quantity]');
    const single = one('[data-single-fields]');
    const mixed = one('[data-mixed-fields]');
    const mixInputs = many('[data-mix-size]');
    const total = one('[data-total-input]');
    const mixedTotal = one('[data-mixed-total]');
    const notes = one('[data-notes]');
    const notesLabel = one('[data-notes-label]');
    const reference = one('[data-quote-reference]');
    const visibleReference = one('[data-visible-reference]');
    if (![form,priceSize,route,size,quantity,single,mixed,total,notes,reference,visibleReference].every(Boolean) || !panels.length) return;
    let strings;
    try { strings = JSON.parse(one('[data-ws-strings]').textContent); } catch (_) { return; }
    const codes = panels.map(p => p.dataset.sizePanel);
    const validSize = value => codes.find(k => k.toLowerCase() === String(value || '').replace(/\u00d7/g,'x').toLowerCase());
    const labels = Object.fromEntries(Array.from(size.options).map(o => [o.value,o.textContent.trim()]));
    const setPanel = key => {
      const code = validSize(key) || codes[0];
      priceSize.value = code;
      panels.forEach(p => { p.hidden = p.dataset.sizePanel !== code; p.open = true; });
    };
    const clearReference = () => {
      if (reference.value) { visibleReference.textContent = strings.changed; visibleReference.hidden = false; }
      reference.value = '';
    };
    const minimumBags = 1000;
    const bagIncrement = 100;
    const syncMixed = () => {
      let sum = 0;
      let invalid = null;
      let underMinimum = null;
      let selected = 0;
      mixInputs.forEach(input => {
        input.setCustomValidity('');
        const count = input.value.trim() === '' ? 0 : Number(input.value);
        if (input.validity.badInput || !Number.isSafeInteger(count) || count < 0 || count % bagIncrement !== 0 || !Number.isSafeInteger(sum + count)) {
          input.setCustomValidity(strings.mixedInvalid);
          if (!invalid) invalid = input;
          return;
        }
        sum += count;
        if (count > 0) {
          selected += 1;
          if (count < minimumBags) {
            input.setCustomValidity(strings.mixedMinimum);
            if (!underMinimum) underMinimum = input;
          }
        }
      });
      if (!invalid && !underMinimum && selected === 0 && mixInputs.length) mixInputs[0].setCustomValidity(strings.mixedEmpty);
      const eligible = !invalid && !underMinimum && selected > 0;
      total.value = eligible ? String(sum) : '';
      const problem = invalid ? strings.mixedInvalid : underMinimum ? strings.mixedMinimum : selected === 0 ? strings.mixedEmpty : '';
      mixedTotal.textContent = strings.mixedTotal.replace('{total}', number(invalid ? 0 : sum)) + (problem ? ' · ' + problem : '');
      mixedTotal.dataset.invalid = problem ? 'true' : 'false';
      return eligible;
    };
    const syncSingle = () => {
      const count = integer(quantity.value);
      const eligible = Number.isFinite(count) && count >= minimumBags && count % bagIncrement === 0;
      quantity.setCustomValidity(quantity.value.trim() && !eligible ? strings.quantityError : '');
      total.value = eligible ? String(count) : '';
      return eligible;
    };
    const syncRoute = () => {
      const singleMode = route.value === 'One size';
      const mixedMode = route.value === 'Mixed sizes';
      single.hidden = !singleMode; single.disabled = !singleMode;
      mixed.hidden = !mixedMode; mixed.disabled = !mixedMode;
      total.disabled = !singleMode && !mixedMode;
      quantity.setCustomValidity('');
      mixInputs.forEach(input => input.setCustomValidity(''));
      notes.required = !singleMode && !mixedMode;
      notesLabel.textContent = notes.required ? strings.customNotes + ' *' : strings.notes;
      if (singleMode) syncSingle(); else if (mixedMode) syncMixed(); else total.value = '';
    };
    const focusForm = () => {
      const target = one('#business-enquiry');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({behavior:reduced ? 'auto' : 'smooth',block:'start'});
      const destination = route.value === 'Mixed sizes' ? mixInputs[0] : (size.value && total.value ? form.querySelector('[autocomplete="name"]') : route);
      destination.focus({preventScroll:true});
      if (history.replaceState) history.replaceState(null,'','#business-enquiry');
    };
    root.addEventListener('click',event => {
      const tierLink = event.target.closest('[data-quote-tier]');
      const routeLink = event.target.closest('[data-route-link]');
      if (tierLink && root.contains(tierLink)) {
        event.preventDefault();
        const row = tierLink.closest('[data-tier]');
        route.value = 'One size'; size.value = row.dataset.size; quantity.value = String(Number(row.dataset.quantity));
        syncRoute();
        const goods = Number(row.dataset.goods); const low = Number(row.dataset.deliveryLow); const high = Number(row.dataset.deliveryHigh);
        const qtyLabel = row.querySelector('.cb-ws__qty').textContent.trim();
        const text = labels[size.value] + ' / ' + qtyLabel + '. ' + strings.goods + ': ' + money(goods) + '; ' + strings.delivery + ': ' + money(low) + '\u2013' + money(high) + '; ' + strings.total + ': ' + money(goods+low) + '\u2013' + money(goods+high) + '. ' + strings.referenceLabel;
        reference.value = goods > 0 && low > 0 && high >= low ? text : '';
        visibleReference.textContent = reference.value; visibleReference.hidden = !reference.value;
        focusForm();
      } else if (routeLink && root.contains(routeLink)) {
        event.preventDefault(); clearReference(); route.value = routeLink.dataset.routeLink; syncRoute(); focusForm();
      }
    });
    priceSize.addEventListener('change',() => setPanel(priceSize.value));
    route.addEventListener('change',() => { clearReference(); syncRoute(); });
    size.addEventListener('change',() => { clearReference(); syncSingle(); });
    quantity.addEventListener('input',() => { clearReference(); syncSingle(); });
    mixInputs.forEach(input => input.addEventListener('input',() => { clearReference(); syncMixed(); }));
    form.addEventListener('submit',event => {
      if (route.value === 'One size' && !syncSingle()) quantity.setCustomValidity(strings.quantityError);
      if (route.value === 'Mixed sizes') syncMixed();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    });
    one('[data-enhanced-form]').hidden = false;
    one('[data-enhanced-form]').disabled = false;
    many('[data-enhanced-only]').forEach(e => { e.hidden = false; });
    one('[data-no-js]').hidden = true;
    const query = new URLSearchParams(location.search);
    const querySize = validSize(query.get('size'));
    const queryQuantity = integer(query.get('quantity') || '');
    if (querySize) size.value = querySize;
    if (Number.isFinite(queryQuantity)) quantity.value = String(queryQuantity);
    if (query.get('mixed') === '1') route.value = 'Mixed sizes';
    setPanel(querySize || priceSize.value); syncRoute();
    root.dataset.ready = 'true';
    const result = one('[data-form-result]');
    if (result) requestAnimationFrame(() => result.focus());
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-cb-wholesale]')) init(scope);
    scope.querySelectorAll('[data-cb-wholesale]').forEach(init);
  }
  window.CelloBagWholesaleRebuild = {initAll};
  document.addEventListener('shopify:section:load',event => initAll(event.target));
  document.addEventListener('shopify:block:select',event => {
    const panel = event.target.closest('[data-size-panel]');
    if (!panel) return;
    const select = panel.closest('[data-cb-wholesale]').querySelector('[data-price-size]');
    select.value = panel.dataset.sizePanel; select.dispatchEvent(new Event('change'));
  });
  initAll(document);
})();
